import React from 'react';
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import {sx} from './sx'
import TabsCustom from "@ui/tabsCustom/TabsCustom";
import ReportBuilderPage from "@pages/reports/reportBuilderPage/ReportBuilderPage";
import NavigateReadyReports from "@containers/reports/readyReports/navigateReadyReports/NavigateReadyReports";

const Reports = () => {
    const {t} = useTranslation()

    const tabs = [
        {
            component: <NavigateReadyReports/>,
            label: t('reportLabels.readyReports'),
        },
        {
            component: <ReportBuilderPage/>,
            label: t('reportLabels.reportBuilder'),
        },
    ]

    return (
        <Box sx={sx.root}>
            <TabsCustom
                tabs={tabs}
            />
        </Box>
    )

};

export default Reports;